<template>
  <v-menu
    ref="menu"
    v-model="part.menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formattedBD"
        :label="$tc('profile.date')"
        filled
        dense
        append-icon="far fa-calendar-alt"
        readonly
        v-bind="attrs"
        class="input_small"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="part.date"
      :max="today"
      @input="send(part.id, part.date)"
      :header-date-format="$datePicker.formatDateHeader"
      :title-date-format="$datePicker.formatTitleDate"
      :weekday-format="$datePicker.formatWeekday"
      :month-format="$datePicker.formatMonth"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
import { VMenu, VDatePicker, VTextField } from "vuetify/lib";
import moment from 'moment-timezone';

export default {
  components: {
    VMenu, VDatePicker, VTextField
  },
  props: {
    part: Object,
  },
  data() {
    return {
      today: new moment().format('YYYY-MM-DD')
    }
  },
  computed: {
    formattedBD() {
      return this.$options.filters.formatDateForHumans(this.part.date, false);
    },
  },
  methods: {
    send(userId, value) {
      this.$emit('send', userId, value, 'date');
      this.part.menu = false;
    }
  },

};
</script>

<style></style>
